function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/removecolumncommand
 */
import { Command } from 'ckeditor5/src/core';
import TableWalker from '../tablewalker';
import { getColumnIndexes, getSelectionAffectedTableCells } from '../utils/selection';
/**
 * The remove column command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'removeTableColumn'` editor command.
 *
 * To remove the column containing the selected cell, execute the command:
 *
 *		editor.execute( 'removeTableColumn' );
 *
 * @extends module:core/command~Command
 */

var RemoveColumnCommand = /*#__PURE__*/function (_Command) {
  _inherits(RemoveColumnCommand, _Command);

  var _super = _createSuper(RemoveColumnCommand);

  function RemoveColumnCommand() {
    _classCallCheck(this, RemoveColumnCommand);

    return _super.apply(this, arguments);
  }

  _createClass(RemoveColumnCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var selectedCells = getSelectionAffectedTableCells(this.editor.model.document.selection);
      var firstCell = selectedCells[0];

      if (firstCell) {
        var table = firstCell.findAncestor('table');
        var tableColumnCount = this.editor.plugins.get('TableUtils').getColumns(table);

        var _getColumnIndexes = getColumnIndexes(selectedCells),
            first = _getColumnIndexes.first,
            last = _getColumnIndexes.last;

        this.isEnabled = last - first < tableColumnCount - 1;
      } else {
        this.isEnabled = false;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this = this;

      var _getBoundaryCells = getBoundaryCells(this.editor.model.document.selection),
          _getBoundaryCells2 = _slicedToArray(_getBoundaryCells, 2),
          firstCell = _getBoundaryCells2[0],
          lastCell = _getBoundaryCells2[1];

      var table = firstCell.parent.parent; // Cache the table before removing or updating colspans.

      var tableMap = _toConsumableArray(new TableWalker(table)); // Store column indexes of removed columns.


      var removedColumnIndexes = {
        first: tableMap.find(function (value) {
          return value.cell === firstCell;
        }).column,
        last: tableMap.find(function (value) {
          return value.cell === lastCell;
        }).column
      };
      var cellToFocus = getCellToFocus(tableMap, firstCell, lastCell, removedColumnIndexes);
      this.editor.model.change(function (writer) {
        var columnsToRemove = removedColumnIndexes.last - removedColumnIndexes.first + 1;

        _this.editor.plugins.get('TableUtils').removeColumns(table, {
          at: removedColumnIndexes.first,
          columns: columnsToRemove
        });

        writer.setSelection(writer.createPositionAt(cellToFocus, 0));
      });
    }
  }]);

  return RemoveColumnCommand;
}(Command); // Returns a proper table cell to focus after removing a column.
// - selection is on last table cell it will return previous cell.


export { RemoveColumnCommand as default };

function getCellToFocus(tableMap, firstCell, lastCell, removedColumnIndexes) {
  var colspan = parseInt(lastCell.getAttribute('colspan') || 1); // If the table cell is spanned over 2+ columns - it will be truncated so the selection should
  // stay in that cell.

  if (colspan > 1) {
    return lastCell;
  } // Normally, look for the cell in the same row that precedes the first cell to put selection there ("column on the left").
  // If the deleted column is the first column of the table, there will be no predecessor: use the cell
  // from the column that follows then (also in the same row).
  else if (firstCell.previousSibling || lastCell.nextSibling) {
      return lastCell.nextSibling || firstCell.previousSibling;
    } // It can happen that table cells have no siblings in a row, for instance, when there are row spans
    // in the table (in the previous row). Then just look for the closest cell that is in a column
    // that will not be removed to put the selection there.
    else {
        // Look for any cell in a column that precedes the first removed column.
        if (removedColumnIndexes.first) {
          return tableMap.reverse().find(function (_ref) {
            var column = _ref.column;
            return column < removedColumnIndexes.first;
          }).cell;
        } // If the first removed column is the first column of the table, then
        // look for any cell that is in a column that follows the last removed column.
        else {
            return tableMap.reverse().find(function (_ref2) {
              var column = _ref2.column;
              return column > removedColumnIndexes.last;
            }).cell;
          }
      }
} // Returns helper object returning the first and the last cell contained in given selection, based on DOM order.


function getBoundaryCells(selection) {
  var referenceCells = getSelectionAffectedTableCells(selection);
  var firstCell = referenceCells[0];
  var lastCell = referenceCells.pop();
  var returnValue = [firstCell, lastCell];
  return firstCell.isBefore(lastCell) ? returnValue : returnValue.reverse();
}